import { gql } from '@apollo/client';
import { SearchFilter } from 'types/Filters';

const listDatasetShareObjects = (datasetUri: string, filter: SearchFilter) => {
    return {
        variables: {
            datasetUri,
            filter,
        },
        query: gql`
            query ListDatasetShareObjects(
                $datasetUri: String!
                $filter: ShareObjectFilter
            ) {
                getDataset(datasetUri: $datasetUri) {
                    shares(filter: $filter) {
                        page
                        pages
                        count
                        nodes {
                            shareUri
                            created
                            owner
                            status
                            approver
                            samlGroupName
                            environmentName
                            shareStageOptions
                        }
                    }
                }
            }
        `,
    };
};

export default listDatasetShareObjects;
